import request from '@/utils/request'
// 登录
export function login(data) {
  return request({
    url: 'login',
    method: 'post',
    data: {
      'username': data.username,
      'password': data.password
    },
    headers: {
      isToken:false,
      "Content-Type":'application/json'
    }
  })
}

// 获取个人信息
export function getInfo() {
  return request({
    url: 'business/trainee/info',
    method: 'get'
  })
}

// 退出接口
export function logout(token) {
  return request({
    url: 'logout',
    method: 'post'
  })
}

// 修改账号密码
export function updatePwd(params) {
  return request({
    url: 'system/user/profile/updatePwd',
    method: 'put',
    data: params,
    header: {
      "Content-Type": 'application/x-www-form-urlencoded'
    }
  })
}
// 修改个人地址
export function editAddress(params) {
  return request({
    url: 'business/trainee/editAddress',
    method: 'put',
    data: params,
    header: {
      "Content-Type": 'application/x-www-form-urlencoded'
    }
  })
}

// 所学课程列表
export function studyProfile(params) {
  return request({
    url: 'business/trainee/studyProfile',
    method: 'get',
    params
  })
}
// 发送短息通知
export function getHairCode(data) {
  return request({
    url: 'system/user/hair-code',
    method: 'post',
    data,
    header: {
      isToken: false
    }
  })
}
// 重置密码
export function resetPassword(data, code) {
  return request({
    url: 'system/user/rest-password?code=' + code,
    method: 'post',
    data,
    header: {
      isToken: false
    }
  })
}

// 修改头像
export function updateAvatar(avatar) {
  return request({
    url: 'system/user/profile/updateAvatar?avatar=' + avatar,
    method: 'post',
  })
}

// 获取公司信息
export function getCompany() {
  return request({
    url: 'business/other/company',
    method: 'get'
  })
}
